const $ = window.jQuery;

if ($) {
	$('.so-widget-sow-accordion').each((_i, container) => {
		$(container).prepend(createButtonContainer());
		container.appendChild(createButtonContainer());
	});
}

function createButtonContainer() {
	const buttonContainer = document.createElement('div');
	buttonContainer.classList.add('accordion-addon-button-container');
	const button = document.createElement('buton');
	button.classList.add('mcw-toggle-all-button', 'button', 'outline');
	button.appendChild(document.createTextNode('Open all'));
	button.addEventListener('click', toggleAllAccordion);
	buttonContainer.appendChild(button);
	return buttonContainer;
}

function toggleAllAccordion(event) {
	const $accordionContainer = $(event.target).parents('.so-widget-sow-accordion');
	const $accordion = $accordionContainer.find('.sow-accordion');

	$accordion.toggleClass('mcw-all-open');
	const isOpen = $accordion.hasClass('mcw-all-open');

	$accordion.find('.sow-accordion-panel').each((_i, panel) => {
		const $panel = $(panel);
		if (isOpen ^ $panel.hasClass('sow-accordion-panel-open')) {
			$panel.find('.sow-accordion-panel-header').click();
		}
	});

	$accordionContainer.find('.mcw-toggle-all-button').text(
		isOpen
			? 'Close all'
			: 'Open all'
	);
}

